// extracted by mini-css-extract-plugin
export var cardTitle = "_cm-1";
export var commentBubble = "_cm-e";
export var commentForm = "_cm-a";
export var commentInput = "_cm-b";
export var commentLabel = "_cm-d";
export var commentPrompt = "_cm-9";
export var csatCard = "_cm-0";
export var feedbackSection = "_cm-7";
export var starDisabled = "_cm-6";
export var starEmpty = "_cm-5";
export var starFilled = "_cm-4";
export var starWrapper = "_cm-3";
export var starsContainer = "_cm-2";
export var submittedComment = "_cm-c";
export var thankYouText = "_cm-8";